/**
 * Web shim for @react-native-firebase/messaging
 * All methods are no-ops on web.
 */

const AuthorizationStatus = {
  NOT_DETERMINED: -1,
  DENIED: 0,
  AUTHORIZED: 1,
  PROVISIONAL: 2,
};

const noop = () => {};
const noopAsync = async () => {};
const noopReturning = (val: any) => () => val;

const messagingInstance = {
  requestPermission: async () => AuthorizationStatus.AUTHORIZED,
  hasPermission: async () => AuthorizationStatus.AUTHORIZED,
  getToken: async () => 'web-no-fcm-token',
  deleteToken: noopAsync,
  onMessage: () => noop,
  onNotificationOpenedApp: () => noop,
  getInitialNotification: async () => null,
  onTokenRefresh: () => noop,
  isDeviceRegisteredForRemoteMessages: true,
  registerDeviceForRemoteMessages: noopAsync,
  setBackgroundMessageHandler: noop,
};

const messaging = () => messagingInstance;
messaging.AuthorizationStatus = AuthorizationStatus;

export default messaging;
export { AuthorizationStatus };
